import React from "react";
import {
  Icon,
  Paragraph,
  TooltipDescriptive,
  useColorTokens
} from "@tvg/design-system";
import { JockeyChange, RaceTypeCodeEnum } from "@tvg/ts-types/Race";
import { orderBy } from "lodash";
import { formatPostTime, formatPeriod } from "@tvg/formatter/dates";

interface Props {
  jockeyChanges: JockeyChange[];
  raceTypeCode: RaceTypeCodeEnum;
  mr?: string;
}
const RunnerChangeIndicator: React.FC<Props> = ({
  jockeyChanges,
  raceTypeCode,
  mr = ""
}) => {
  const colorTokens = useColorTokens();

  if (!jockeyChanges.length) {
    return null;
  }

  return (
    <TooltipDescriptive
      header=""
      qaLabel="jockey-changes-tooltip"
      onAction="hover"
      widthContent="auto"
      placement="bottom-mid"
      body={
        <>
          {orderBy(jockeyChanges, ["date"], ["desc"]).map((change, index) => (
            <Paragraph
              key={change.date}
              qaLabel={`jockey-change-${index}`}
              color={colorTokens.content.onDark}
            >
              <>
                <Paragraph
                  qaLabel="text-date-changes"
                  color={colorTokens.content.onDark}
                  mr="space-1"
                >
                  <>
                    {formatPostTime(change.date)} {formatPeriod(change.date)}
                  </>
                </Paragraph>
                <Paragraph
                  qaLabel="text-keyword"
                  mr="space-1"
                  fontWeight="600"
                  color={colorTokens.content.onDark}
                >
                  {raceTypeCode === RaceTypeCodeEnum.HARNESS
                    ? "Driver"
                    : "Jockey"}
                </Paragraph>
                <Paragraph
                  qaLabel="text-setTo"
                  color={colorTokens.content.onDark}
                >
                  {change.oldValue || "Set to\u00A0"}
                </Paragraph>
                {change.oldValue && change.newValue ? (
                  <Icon
                    name="arrowRight"
                    size="s"
                    mr="space-1"
                    ml="space-1"
                    lineColor={colorTokens.content.onDark}
                  />
                ) : null}
                <Paragraph
                  qaLabel="text-change-newValue"
                  color="orange.400"
                  fontWeight="600"
                >
                  {change.newValue}
                </Paragraph>
              </>
            </Paragraph>
          ))}
        </>
      }
    >
      <Icon
        qaLabel="jockey-change"
        name="changes"
        size="s"
        ml="space-1"
        mr={mr}
      />
    </TooltipDescriptive>
  );
};

export default RunnerChangeIndicator;
